import { Link } from "@tanstack/react-router";

/**
 * Non-intrusive entry point to the Zakat Calculator.
 * Placed directly below the live price table on every city / wildcard layout.
 */
export function ZakatCtaBanner() {
  return (
    <div className="mt-4">
      <Link
        to="/zakat-calculator"
        className="group block rounded-2xl border border-gold/40 bg-gradient-to-br from-gold/10 via-background/40 to-primary/10 backdrop-blur-xl px-4 py-3.5 md:px-5 md:py-4 shadow-sm hover:shadow-md hover:border-gold/70 transition-all"
      >
        <div className="flex items-center justify-between gap-3">
          <div className="flex items-center gap-3 min-w-0">
            <span aria-hidden className="text-2xl shrink-0">🕌</span>
            <div className="min-w-0">
              <div className="text-sm md:text-base font-semibold text-foreground truncate">
                Calculate Zakat On Your Gold Now
              </div>
              <div className="text-xs md:text-[13px] text-muted-foreground">
                Instant 2.5% Zakat on your tolas of gold, silver &amp; cash
              </div>
            </div>
          </div>
          <span className="text-xs md:text-sm font-semibold text-gold whitespace-nowrap group-hover:translate-x-0.5 transition-transform">
            Open →
          </span>
        </div>
      </Link>
    </div>
  );
}